"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserAudioMarkerParameters = void 0;
exports.UserAudioMarkerParameters = [
    {
        id: 'recording',
        label: 'Recording File',
        description: 'Input Param - List of options from which the user needs to select the correct ones',
        type: 'string',
        paramType: 'FILE',
        required: true,
    },
    {
        id: 'min',
        label: 'Minimum Markers',
        description: 'Input Param - Minimum number of markers required',
        type: 'int',
        paramType: 'INT',
        required: false,
    },
    {
        id: 'max',
        label: 'Maximum Markers',
        description: 'Input Param - Maximum number of markers required',
        type: 'int',
        paramType: 'INT',
        required: false,
    },
    {
        id: 'markers',
        label: 'Markers',
        description: 'Output Param - List of integer timestamps for each marker in milliseconds',
        type: 'output',
        paramType: 'INT_ARRAY',
        required: true,
    },
];
//# sourceMappingURL=UserAudioMarkerComponent.js.map